import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LookupComponent } from './lookup/lookup.component';
import { StpMaterialModule } from '../material/material.module';
import { StpFormsModule } from '../../stp-app/forms/forms.module';
import { StpSelectModule } from '../select/select.module';

@NgModule({
  imports: [
    CommonModule,
    StpMaterialModule,
    StpFormsModule,
    StpSelectModule
  ],
  exports: [
    LookupComponent
  ],
  declarations: [
    LookupComponent
  ]
})
export class StpLookupsModule { }
